// extracted by mini-css-extract-plugin
export default {"selectLang":"SelectLangRow-selectLang_CwsEI"};